import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PortalNavbarComponent } from './portal-navbar.component';

@Component({
  selector: 'app-public-landing-page',
  standalone: true,
  imports: [CommonModule, PortalNavbarComponent],
  template: `
    <div class="page">
      <app-portal-navbar></app-portal-navbar>
      <section class="hero">
        <div class="hero-inner">
          <h1 class="hero-title">Welcome to United Team Building</h1>
          <p class="hero-sub">Engage. Compete. Connect. The platform for modern team events and collaboration.</p>
        </div>
      </section>
      <section class="info-cards">
        <div class="cards-grid">
          <div class="info-card">
            <h3>Learn More</h3>
            <p>Discover how United Team Building can transform your organization’s events.</p>
            <a href="https://www.example.com/learn" target="_blank">Learn More</a>
          </div>
          <div class="info-card">
            <h3>Contact Us</h3>
            <p>Have questions? Reach out to our team for more information.</p>
            <a href="https://www.example.com/contact" target="_blank">Contact</a>
          </div>
          <div class="info-card">
            <h3>Company Website</h3>
            <p>Visit our main website for more about our mission and services.</p>
            <a href="https://www.example.com" target="_blank">Company Site</a>
          </div>
        </div>
      </section>
    </div>
  `,
  styles: [`
    .hero { background: linear-gradient(120deg, #8b5cf6 0%, #6366f1 100%); color: #fff; padding: 3rem 1.5rem 2.5rem; }
    .hero-inner { max-width: 900px; margin: 0 auto; text-align: center; }
    .hero-title { font-size: 2.5rem; font-weight: 800; margin-bottom: 1rem; }
    .hero-sub { font-size: 1.2rem; color: #e0e7ff; }
    .info-cards { background: #f8fafc; padding: 2.5rem 1.5rem; }
    .cards-grid { display: flex; gap: 2rem; justify-content: center; flex-wrap: wrap; max-width: 1100px; margin: 0 auto; }
    .info-card { background: #fff; border-radius: 1rem; box-shadow: 0 2px 12px #0001; padding: 2rem 1.5rem; max-width: 320px; flex: 1 1 260px; display: flex; flex-direction: column; align-items: flex-start; }
    .info-card h3 { margin-top: 0; font-size: 1.2rem; color: #8b5cf6; }
    .info-card p { color: #334155; margin-bottom: 1.2rem; }
    .info-card a { color: #6366f1; text-decoration: none; font-weight: 600; }
    .info-card a:hover { text-decoration: underline; }
  `]
})
export class PublicLandingPageComponent {}
